import { render } from "./LabeledButton.vue?vue&type=template&id=7073cf6f&scoped=true"
import script from "./LabeledButton.vue?vue&type=script&lang=js"
export * from "./LabeledButton.vue?vue&type=script&lang=js"

import "./LabeledButton.vue?vue&type=style&index=0&id=7073cf6f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7073cf6f"]])

export default __exports__